export default __webpack_public_path__ + "static/media/icon__table.b7ddc081.svg";